import React from 'react'
import './PreloaderNew.css'

const PreloaderNew = ({top}) => {
    return (
        <div  className="loaderPosition">
        <div className="loader"/>
      </div>
    )
};

export default PreloaderNew;
